import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  TaskDTO,
  DocumentClassDTO
} from '../../api/plyca-dtos';

import { Configuration } from '../../conf/app.constants';
import { ExpenseDocumentLinkDTO, ExpenseManagementLineDTO, } from '../../api/plyca-dtos-v2';
import { AppConfiguration } from '../../conf/app.configuration';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { generateRandomIdentifier } from '../../ui.service';
import { finalize, switchMap } from 'rxjs/operators';


@Component({
  selector: 'accountingDocumentTypes',
  templateUrl: 'accountingDocumentTypes.template.html'
})
export class AccountingDocumentTypesComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  showHeader = true;
  loading = false;
  origen: ExpenseManagementLineDTO;
  types: ExpenseDocumentLinkDTO[];
  task: TaskDTO;
  customizeTableMode = false;
  public windowHash: string;
  tagsParent: string[];

  constructor(
    private plycaService: PlycaDataService,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public waitService: WaitLoadingService,
    public translationService: TranslateService,
    public helpService: HelpService
  ) {
    super();
    this.waitService.startWaiting();
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.EXPENSE_DOCUMENT_TYPES)
        }
      )));
    this.windowHash = generateRandomIdentifier();

    this.origen = this.dialogConfig['origen'];
    this.task = this.dialogConfig['task'];
    this.loading = true;
  }



  ngAfterContentInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        super.ngOnDestroy();
      })));

    super.ngOnDestroy();
  }

  loadData() {
    let _abbreviation = this.origen.documentClassDTO.abbreviation; // 'RC';
    let _sign = '' + this.origen.sign; // 'false';


    let customizeTable = this.appConfig.getValue('accountingDocumentTypes.table.customize');
    if (customizeTable) {
      this.customizeTableMode = true;
    }
    console.log('customizeTable: ' + customizeTable);

    let _documentType = '-';
    if (this.origen.accountingDocumentType) {
      _documentType = this.origen.accountingDocumentType; // 'RC';
    }

    let _exerciseClassification = this.origen.CP;
    // if (this.origen.expenseAmount) {
    //   if (this.origen.expenseAmount.earlyProcessingAmount && this.origen.expenseAmount.earlyProcessingAmount > 0) {
    //     _exerciseClassification = 'TRAMITACIONANTICIPADA';
    //   } else if (this.origen.expenseAmount.futureAmount && this.origen.expenseAmount.futureAmount > 0
    //     && (this.origen.expenseAmount.currentAmount == undefined || this.origen.expenseAmount.currentAmount == 0)) {
    //     _exerciseClassification = 'FUTURO';
    //   }
    //   if (this.origen.expenseAmount.currentAmount && this.origen.expenseAmount.currentAmount > 0
    //     && this.origen.expenseAmount.futureAmount == undefined || this.origen.expenseAmount.futureAmount == 0) {
    //     _exerciseClassification = 'CORRIENTE';
    //   }
    // }

    let contexWork = this.task.work.context;
    let fasesCrear: Array<string> = contexWork.configurations['newExpenseDocumetTypes'].value;
    let _isExerciseChange = contexWork.configurations['isExerciseChange'].value;




    let url =
      this.configuration.EXPENSE_DOCUMENT_LINKS_SERVICE_URL +
      '?exerciseChange=' +
      _isExerciseChange +
      '&abbreviation=' +
      _abbreviation +
      '&sign=' +
      _sign +
      '&documentType=' +
      encodeURIComponent(_documentType);

    if (_exerciseClassification) {
      url = url + '&exerciseClassification=' + _exerciseClassification;
    }

    /*

    let filterParams: any;
    filterParams = {};
    if (_exerciseClassification) {
      filterParams.exerciseClassification = _exerciseClassification;
    }
    filterParams.exerciseChange = _isExerciseChange;
    filterParams.abbreviation = _abbreviation;
    filterParams.sign = _sign;
    filterParams.documentType = encodeURIComponent(_documentType);

    Importante!!!!!!

    Funciona encodeURIComponent(_documentType) pero al montar la url con filterParams es como si
    lo codificará dos veces!!

     documentType=2030%252B2230

     en vez de:

     documentType=2030%2B2230


     https://stackoverflow.com/questions/49438737/how-to-escape-angular-httpparams

     this.plycaService.query<ExpenseDocumentLinkDTO>(
     this.configuration.EXPENSE_DOCUMENT_LINKS_SERVICE_URL,
     filterParams
   ).subscribe((datos: any) => {*/


    this.subscribe(this.plycaService.query<ExpenseDocumentLinkDTO>(url),

      (datos: any) => {
        if (datos && datos.content) {
          let types = datos.content;
          let filteredExpenseDocumentLink: Array<ExpenseDocumentLinkDTO> = [];
          fasesCrear.forEach(item => {
            try {
              let expenseDocumentLink = new ExpenseDocumentLinkDTO();
              expenseDocumentLink.childSign = 0;

              let documentClass = {} as DocumentClassDTO;
              documentClass.abbreviation = item;

              expenseDocumentLink.childDocumentClass = documentClass;

              if (item.endsWith('/')) {
                expenseDocumentLink.childSign = 1;
                expenseDocumentLink.childDocumentClass.abbreviation = expenseDocumentLink.childDocumentClass.abbreviation.replace('/', '');
              }
              filteredExpenseDocumentLink.push(expenseDocumentLink);
            } catch (error) {
              console.error(error);
            }
          });
          types = types.filter((encadenamiento: ExpenseDocumentLinkDTO) => filteredExpenseDocumentLink.find(
            (b) => (
              (encadenamiento.childDocumentClass.abbreviation === b.childDocumentClass.abbreviation)
              && ((encadenamiento.childSign === b.childSign)
                //	Si el se alimenta en la variable de procedimiento /, además de los hijos de signo 1 se deben mostrar los
                // de signo 0 que sean multisigno
                || (encadenamiento.childExpenseDocumentType.multipleSign && encadenamiento.childSign === 0))
            )
          ) !== undefined
          );

          // this.types.sort((a, b) =>
          //   a.description.toLowerCase() < b.description.toLowerCase()
          //     ? -1
          //     : a.description.toLowerCase() > b.description.toLowerCase()
          //     ? 1
          //     : 0
          // );
          this.types = types;
        } else {
          console.log('A partir del documento seleccionado no se han encontrado definidos en la tabla GG_ENCADENAMIENTO posible tipos de documentos contables.' + url);
        }
        this.loading = false;
        this.waitService.cancelWaiting();
      });
  }

  isLoading(): boolean {
    return this.loading;
  }

  cancel(): void {
    this.ref.close();
  }


  getSign(type: ExpenseDocumentLinkDTO) {
    if (type.childExpenseDocumentType.multipleSign) {
      let multisigno = this.translationService.instant('ExpenseDocumentTypes.sign.multisigno')
      return multisigno;//+/-
    } else if (type.childSign === 1) {
      return this.translationService.instant('ExpenseDocumentTypes.sign.barrado'); //'-'
    } else {
      return this.translationService.instant('ExpenseDocumentTypes.sign.positivo');//'+'
    }
  }
  selectType(type: ExpenseDocumentLinkDTO) {
    this.waitService.startWaiting();
    if (type) {
      console.log('Type', type);
      this.ref.close(type);
    }
  }
}